import PropTypes from "prop-types"
import { map, get, isFunction } from "lodash"
import classNames from "classnames"
import { List, ListItemButton, Grid, ListSubheader } from "@mui/material"
import { COLUMNS } from "../shapes"

function makeClick(index, click) {
  if (index === 0) { return undefined }
  return () => click()
}

function getValue(column, category) {
  const { id, formatter, render } = column
  // Render overrides formatter
  if (isFunction(render)) {
    return render(category)
  }

  if (isFunction(formatter)) {
    return formatter(get(category, id))
  }

  return get(category, id)
}
export default function FactorCategories({ categories, selectedFactorCategory, setFactorCategory, columns }) {
  return <List>
    <ListSubheader disableSticky className="factor-categories-subheader">
      <Grid container>
        <Grid item xs className="label" />
        {map(columns, ({ id, name }) => <Grid key={id} item xs>{name}</Grid>)}
      </Grid>
    </ListSubheader>
    {map(categories, (category, index) => <ListItemButton
      key={category.id}
      onClick={makeClick(index, () => setFactorCategory(category.id))}
      disabled={index === 0}
      selected={category.id === selectedFactorCategory}
      className={classNames("category", category.id)}
    >
      <Grid container>
        <Grid item xs className="label">
          {category.id}
        </Grid>
        {map(columns, (column) => <Grid key={get(column, "id")} item xs>{getValue(column, category)}</Grid>)}
      </Grid>
    </ListItemButton>,
    )}
  </List>
}

FactorCategories.propTypes = {
  categories: PropTypes.array.isRequired,
  selectedFactorCategory: PropTypes.string.isRequired,
  setFactorCategory: PropTypes.func.isRequired,
  columns: COLUMNS.isRequired,
}
